import $ from "/srv/www/p/pathologiefriesland.nl/vhosts/www/htdocs/wp-content/plugins/wp-soup-framework/node_modules/jquery";

$(document).ready(function () {
  $("form.cart").on("click", ".plus, .minus", function () {
    // Get current quantity values
    var qty = $(this).closest("form.cart").find(".qty");
    var val = parseFloat(qty.val());
    var max = parseFloat(qty.attr("max"));
    var min = parseFloat(qty.attr("min"));
    var step = parseFloat(qty.attr("step"));

    // Change the value if plus or minus
    if ($(this).is(".plus")) {
      if (max && max <= val) {
        qty.val(max);
      } else {
        qty.val(val + step);
      }
    } else {
      if (min && min >= val) {
        qty.val(min);
      } else if (val > 1) {
        qty.val(val - step);
      }
    }
  });
});
// $(document).on("click", ".plus", function (e) {
//   let input = $(this).parent().siblings("input.qty");
//   if (input.length === 0) {
//     return;
//   }

//   input = $(input[0]);
//   let inputName = input.attr("name");
//   let inputID = input.attr("id");
//   // Search for second input with the same name to work around correctly updating the cart.
//   let secondInput = $(`input[name='${inputName}']:not([id='${inputID}'])`);
//   const max = parseInt(input.attr("max"));
//   const val = parseInt(input.val());
//   let step = input.attr("step");
//   step = "undefined" !== typeof step ? parseInt(step) : 1;
//   if (isNaN(max) || val < max) {
//     input.val(val + step).change();
//     if (secondInput.length !== 0) {
//       secondInput.val(val + step).change();
//     }
//   }
// });

// $(document).on("click", ".minus", function (e) {
//   let input = $(this).parent().siblings("input.qty");
//   if (input.length === 0) {
//     return;
//   }

//   input = $(input[0]);
//   let inputName = input.attr("name");
//   let inputID = input.attr("id");
//   // Search for second input with the same name to work around correctly updating the cart.
//   let secondInput = $(`input[name='${inputName}']:not([id='${inputID}'])`);
//   const val = parseInt(input.val());
//   let step = input.attr("step");
//   step = "undefined" !== typeof step ? parseInt(step) : 1;
//   if (val > 0) {
//     input.val(val - step).change();
//     if (secondInput.length !== 0) {
//       secondInput.val(val - step).change();
//     }
//   }
// });

$(function () {
  const quantityInputHeight = $(
    ".woocommerce .input-group-field.qty"
  ).outerHeight();
  if (quantityInputHeight != null) {
    $(".woocommerce .add-to-cart-box .single_add_to_cart_button").outerHeight(
      quantityInputHeight
    );
  }
});

$(document).ready(function () {
  //logo menu
  $(".logo-block .logo-image.second-logo-img").hide();
  $(".home .wp-block-videopopupblock-popup-player").hide();
  $(".icon-after-menu").hide();
  $(".mfp-close, #wooac-continue").click(function () {
    var url = document.location.href;
    window.history.pushState({}, "", url.split("?")[0]);
  });

  //video slider
  const swiper = document.querySelector(
    ".header-slider .swiper-container"
  )?.swiper;
  if (swiper) {
    /* GET ALL VIDEOS */
    var sliderVideos = $(".homepagina-video");
    sliderVideos.on("ended", function () {
      swiper.slideNext();
    });

    /* SWIPER API - Event will be fired after animation to other slide (next or previous) */
    swiper.on("slideChange", function () {
      console.log("slide changed");
      /* stop all videos (currentTime buggy without this loop idea) */
      sliderVideos.each(function (index) {
        this.currentTime = 0;
      });

      /* SWIPER GET CURRENT AND PREV SLIDE (AND VIDEO INSIDE) */
      var prevVideo = $(
        "[data-swiper-slide-index=" + this.previousIndex + "]"
      ).find("video");
      var currentVideo = $(
        "[data-swiper-slide-index=" + this.realIndex + "]"
      ).find("video");
      currentVideo.trigger("play");
      prevVideo.trigger("stop");
    });
  }

  const popupClosed = localStorage.getItem("Video-Clicked");
  if (popupClosed) {
    const value = JSON.parse(popupClosed).value;
    if (value === "yes") {
      $(".home .wp-block-videopopupblock-popup-player").addClass("hide");
    }
  } else {
    $(".home .wp-block-videopopupblock-popup-player").removeClass("hide");
    $(".home .wp-block-videopopupblock-popup-player").show();
  }

  //video popup cookie
  $(".modal-video-close-btn").click(function () {
    $(".home .wp-block-videopopupblock-popup-player").addClass("hide");
    var date = new Date();
    const today = new Date().getTime();
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
    localStorage.setItem(
      "Video-Clicked",
      JSON.stringify({
        value: "yes",
        expDate: date,
      })
    );
    const popupClosed = localStorage.getItem("Video-Clicked");

    const expDate = JSON.parse(popupClosed).expDate;
    const value = JSON.parse(popupClosed).value;
  });
});

$(window).on("scroll", function () {
  const screenSize = $(window).width();
  if (screenSize > 1023) {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      $(".after-menu-containter").hide();
      $(".icon-after-menu").show();
      $(".logo-block .logo-image.first-logo-img").hide();
      $(".logo-block .logo-image.second-logo-img").show();
    } else {
      $(".after-menu-containter").show();
      $(".icon-after-menu").hide();
      $(".logo-block .logo-image.first-logo-img").show();
      $(".logo-block .logo-image.second-logo-img").hide();
    }
  }
});

function equalColumns() {
  let screenSize = $(window).width();
  $(".equal-columns").each(function (index) {
    $(this).attr("data-equalizer", `equal-columns-${index}`);
    const wpsoupCard = $(this).find(
      ".wp-block-column .related-page-card .card"
    );
    wpsoupCard.attr("data-equalizer-watch", `equal-columns-${index}`);

    if (screenSize >= 1025) {
      $(document).foundation();
    }
  });
}
window.addEventListener("resize", equalColumns);
$(window).on("load", function () {
  equalColumns();
  window.addEventListener("resize", equalColumns);
  let urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("add-to-cart")) {
    var url = document.location.href;
    window.history.pushState({}, "", url.split("?")[0]);
  }
});

$(window).on("resize", function () {
  equalColumns();
});
